<template>
  <div v-if="isShow" class="interview-grade">
    <div class="close" @click="isShow = false">X</div>
    <div class="interview-grade-contentbox">
      <div class="radish-detail">
        <span>{{ radish.姓名 }}</span>
        <span v-for="field in showRadishFields" :key="field" v-if="radish[field]">
          {{ field }}:{{ radish[field] }}
        </span>
      </div>
      <div class="radish-files">
        <span>附件:</span>
        <FileList :files="radishFiles"></FileList>
      </div>
      <div class="radish-score border-top">
        <h4>口碑评价：</h4>
        <div class="score">
          <div class="flex">
            <span>评价（{{ score.数量 }}）</span>
            <span>平均分：{{ score.平均分 }}</span>
          </div>
          <div class="score-left">
            <ul>
              <li v-for="item in scoretype" :key="item">
                <div class="score-title">{{ item }}</div>
                <div class="score-score">
                  <i v-if="score[item] >= 0" class="el-icon-star-on btn"></i>
                  <i v-else class="el-icon-star-off btn"></i> <span>{{ score[item] }}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="score-right">
            <ul>
              <li v-for="item in scoretype" :key="item">
                <i class="el-icon-remove-outline btn" v-if="type[item] == '+'" @click="type[item] = '-'"></i>
                <i class="el-icon-circle-plus-outline btn" v-else-if="type[item] == '-'" @click="type[item] = '+'"></i>
                <el-rate
                  v-model="newscore[item]"
                  v-if="type[item] == '+'"
                  void-icon-class="el-icon-star-on"
                  :icon-classes="['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on']"
                  style="width:85%;display:inline-block"
                ></el-rate>
                <el-rate
                  v-model="newscore[item]"
                  v-else-if="type[item] == '-'"
                  :colors="['#da3c3c', '#da3c3c', '#da3c3c']"
                  void-icon-class="el-icon-remove"
                  :icon-classes="['el-icon-remove', 'el-icon-remove', 'el-icon-remove']"
                  style="width:85%;display:inline-block"
                ></el-rate>
              </li>
            </ul>
          </div>
          <ul class="grades-box">
            <li v-for="grade in grades" :key="grade._id">
              <span class="remark-date" v-if="grade.user">
                {{ getDate(grade.createdAt) }} <span class="remark-time">{{ getTime(grade.createdAt) }}</span> --
                {{ grade.user }}
              </span>
              <span class="remark-date" v-else> 2019/4/20 <span class="remark-time">00:00</span> -- admin </span>
              <span v-for="type in scoretype" :key="type" v-if="grade[type]"> {{ type }}:{{ grade[type] }} </span>
              <span class="grades-evaluate">{{ grade.evaluate }}</span>
            </li>
          </ul>
          <ul class="interviewGrades-box">
            <li v-for="grade in interviewScore" :key="grade._id">
              <span class="remark-date" v-if="grade.user">
                {{ getDate(grade.updatedAt) }} <span class="remark-time">{{ getTime(grade.updatedAt) }}</span> --
                {{ grade.user }}
              </span>
              <el-tag size="mini">{{grade.意见}}</el-tag>
              <el-tag size="mini">第{{grade.轮数}}轮</el-tag>
              <span class="evaluate">{{ grade.综合评价 }}</span>
              <el-tag size="mini" type="warning"  v-for="(val,type) in grade['projectGrades']" :key="type" v-if="val">{{ type }}:{{ val }}</el-tag>
            </li>
          </ul>

          <div class="evaluate">
            <el-input type="textarea" autosize :rows="2" placeholder="口碑评价备注" v-model="evaluate"> </el-input>
          </div>
        </div>
      </div>
      <ul class="project-tag-score border-top">
        <h4>面试评价：</h4>
        <li v-for="(val, tag) in projectGrades" :key="tag" style="overflow:hidden">
          <span class="left-hand">{{ tag }}:</span>
          <div class="right-hand">
            <i
              class="el-icon-remove-outline btn"
              v-if="projectGradeType[tag] == '+'"
              @click="projectGradeType[tag] = '-'"
            ></i>
            <i
              class="el-icon-circle-plus-outline btn"
              v-else-if="projectGradeType[tag] == '-'"
              @click="projectGradeType[tag] = '+'"
            ></i>
            <el-rate
              v-model="projectGrades[tag]"
              v-if="projectGradeType[tag] == '+'"
              void-icon-class="el-icon-star-on"
              :icon-classes="['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on']"
              style="display:inline-block"
            ></el-rate>
            <el-rate
              v-model="projectGrades[tag]"
              v-else-if="projectGradeType[tag] == '-'"
              :colors="['#da3c3c', '#da3c3c', '#da3c3c']"
              void-icon-class="el-icon-remove"
              :icon-classes="['el-icon-remove', 'el-icon-remove', 'el-icon-remove']"
              style="display:inline-block"
            ></el-rate>
          </div>
        </li>
      </ul>
      <div>
        <span>综合评价：</span>
        <el-input type="textarea" autosize :rows="3" placeholder="综合评价" v-model="interviewGrade.综合评价">
        </el-input>
      </div>
      <div>
        <el-radio-group v-model="radio">
          <el-radio label="强烈推荐">强烈推荐</el-radio>
          <el-radio label="推荐">推荐</el-radio>
          <el-radio label="待定">待定</el-radio>
          <el-radio label="不合适">不合适</el-radio>
        </el-radio-group>
        <!-- <el-input
          v-if="showInputType.includes(radio)"
          type="textarea"
          autosize
          :rows="2"
          :placeholder="radio2text[radio]"
          v-model="interviewGrade['满意度'][radio]"
        >
        </el-input> -->
      </div>
    </div>
    <!-- 扩展界面 -->
    <!-- <div class="interview-grade-questions">
      <el-tabs v-model="activeName">
        <el-tab-pane label="卖笔测试" name="first">
          <h4>单面环节一（无限可能的笔）</h4>
          <pre>
任务说明：
你的手边是一支拥有无限可能的笔，你可以赋予它任何功能、各种作用、特征，只要你能想得到。
你也可以运用各种方法、设置各种场景、设定我的角色。

我们最终只有一个目的，就是用不低于500块的价格，将你的笔卖给我，这将是你成败与否的唯一标准。

（你有1分钟的准备时间，和5分钟的营销时间）
          </pre>
          <p>考察目标与考察内容</p>
          <p>1. “匹配意识”:角色&功能的设定意识，是否抓匹配</p>
          <p>2. “沟通表达”:沟通风格、说服力</p>
          <p>3. “受挫反应”:被拒绝后的反应举措</p>
          <p>4. “结果导向”:最终是否达成交易/是否始终关注达成</p>
        </el-tab-pane>
        <el-tab-pane label="一对一沟通" name="second">
          <h4>单面环节二（问题沟通）</h4>
          <p>核心考察目标</p>
          <pre>
1. 自我驱动力（需案例）:不需要上司谆谆教导，领悟力强，执行力强，只要上司和客户告知目标，会穷尽一切方式去完成case。主动PUSH客户要反馈，主动追着上司学习业务流程，主动追着候选人要referral。
2. 抗挫折能力（需案例）:皮实。能扛得住上司的PUSH，禁得住客户的challenge与投诉，忍得住候选人的质疑与反复无常。
3. 快速学习能力（需案例）:快速了解一块新业务/新职位；沟通中迅速形成自己的思考框架；快速学习同时快速输出。
4. 沟通能力:快速获得信任感；影响和带动沟通气氛的能力；说服他人（使自己意见被他人接受的能力）。</pre
          >

          <span>问题描述：</span>
          <p v-for="(ques,index) in question" :key="ques">{{index+1}}:{{ques}}</p>
        </el-tab-pane>
        <el-tab-pane label="实战演练" name="third">
          <h4>单面环节三（找人大作战）</h4>
          <pre>
目标：找到项目需要的合适人选，推动考虑机会，并mapping相应公司。
成功条件：
    A-对方考虑机会，并同意推荐，要到简历；
    B-对方不考虑机会，但是了解到人选标签或实现公司mapping；
    C-获得有用信息（帮助寻找匹配项目的合适人选）。
          </pre>
        </el-tab-pane>
      </el-tabs>
    </div> -->
    <div>
      <!-- <el-button style="float:right;margin:8px;" type="primary" size="mini" @click="save">保存</el-button> -->
      <div class="radish-btn radish-btn-primary radish-btn-small" style="float:right;margin:8px;" @click="save">保存</div>
    </div>
  </div>
</template>
<script>
import FileList from '../baseComponent/FileList'
import * as commonvariant from '../../statistics/variant/commonvariant.js'
import * as fixedvariant from '../../statistics/variant/fixedvariant.js'

export default {
  components: { FileList },
  data() {
    return {
      idObj: {},
      isShow: false,
      activeName: 'first',
      showRadishFields: ['公司', '目前职位', '性别'],
      radishFiles: [],
      radish: {},
      score: {},
      grades: [],
      type: {
        业绩: '+',
        管理能力: '+',
        专业高度: '+',
        资源: '+',
        口碑: '+',
        情商: '+',
      },
      newscore: JSON.parse(JSON.stringify(commonvariant.分数统计)),
      radio: '',
      // showInputType: ['再考察', '待定', '有风险'],
      scoretype: ['业绩', '管理能力', '专业高度', '资源', '口碑', '情商'],
      evaluate: '',
      projectTags: [],
      projectGrades: {},
      projectGradeType: {},
      // radio2text: {
      //   再考察: '重点考察点',
      //   待定: '待定备注',
      //   有风险: '风险点',
      // },
      question: fixedvariant.面试问题,
      questionIndex: '0',
      questionRemark: {},
      interviewScore: [],
      interviewGrade: {},
    }
  },
  methods: {
    changeQuestion(index) {
      this.questionIndex = `${index - 1}`
    },
    getTime(time) {
      let hour = new Date(time).getHours()
      let minute = new Date(time).getMinutes()
      hour = hour < 10 ? `0${hour}` : hour
      minute = minute < 10 ? `0${minute}` : minute
      return `${hour}:${minute}`
    },
    getDate(val) {
      let year = new Date(val).getFullYear()
      let month = new Date(val).getMonth() + 1
      let data = new Date(val).getDate()
      return `${year}/${month}/${data}`
    },
    async open(data) {
      this.idObj = data
      const { pid, rid, round } = data
      const res = await app.service('company').getInterviewGrade({ user: app.user.account, rid, pid, round })
      if (res.status === 'success') {
        this.radish = res.data.radish
        this.score = res.data.score
        this.grades = res.data.grades
        this.interviewGrade = res.data.interviewGrade || {
          综合评价: '',
        }
        this.radio = this.interviewGrade.意见 || ''
        this.projectTags = res.data.projectTags || []
        this.init(rid)
        this.isShow = true
      } else this.$message.error(res.msg)
    },
    init(rid) {
      this.newscore = JSON.parse(JSON.stringify(commonvariant.分数统计))
      this.evaluate = ''
      // this.interviewGrade['提问'] = this.interviewGrade['提问'] || {}
      this.questionRemark = this.interviewGrade['提问'] || {}
      const keys = Object.keys(this.questionRemark)
      for (let i = 0; i < 9; i++) {
        if (!keys.includes(i + '')) this.$set(this.questionRemark, i, '')
      }
      this.getRadishFiles(rid)
      this.getInterviewScore(rid)
      this.initProjectTags()
    },
    initProjectTags() {
      const { projectGrades = {} } = this.interviewGrade
      const obj = {}
      const keys = []
      this.projectTags.forEach(key => {
        if (projectGrades[key]) {
          this.$set(this.projectGradeType, key, projectGrades[key] > 0 ? '+' : '-')
          obj[key] = Math.abs(projectGrades[key])
          keys.push(key)
        } else {
          obj[key] = 0
          this.$set(this.projectGradeType, key, '+')
        }
      })
      Object.keys(projectGrades).forEach(key => {
        if (!keys.includes(key)) {
          this.$set(this.projectGradeType, key, projectGrades[key] > 0 ? '+' : '-')
          obj[key] = Math.abs(projectGrades[key])
          keys.push(key)
        }
      })
      this.projectGrades = obj
    },
    async getRadishFiles(rid) {
      const res = await app.service('radish').listAttachment({ rid })
      if (res.status === 'success') this.radishFiles = res.data
      else this.$message.error(res.msg)
    },
    async getInterviewScore(rid) {
      const res = await app.service('company').getInterviewScore({ rid })
      if (res.status === 'success') this.interviewScore = res.data
      else this.$message.error(res.msg)
    },
    async save() {
      const hasVal = this.checkScore()
      if (hasVal) this.savescore()
      const saveInterviewGrade = JSON.parse(JSON.stringify(this.interviewGrade))
      let option = JSON.parse(JSON.stringify(this.projectGrades))
      for (let key in this.projectGradeType) {
        if (this.projectGradeType[key] == '-') {
          option[key] = -option[key]
        }
      }
      saveInterviewGrade['projectGrades'] = option
      saveInterviewGrade.意见 = this.radio
      const saveOption = Object.assign(saveInterviewGrade, this.idObj, { user: app.user.account })
      const res = await app.service('company').saveInterviewGrade(saveOption)
      if (res.status == 'success') {
        this.$message('保存成功')
        this.open(this.idObj)
      } else {
        this.$message.error(res.msg)
      }
    },
    checkScore() {
      let hasVal = false
      Object.keys(this.newscore).forEach(key => {
        if (this.newscore[key]) hasVal = true
      })
      if (this.evaluate) hasVal = true
      return hasVal
    },
    async savescore() {
      let option = JSON.parse(JSON.stringify(this.newscore))
      for (let key in this.type) {
        if (this.type[key] == '-') {
          option[key] = -option[key]
        }
      }
      option.rid = this.idObj.rid
      let result = await window.app.service('company').insertRadishScore({ score: option, evaluate: this.evaluate })
      if (result.status != 200) {
        this.$message(result.msg)
      }
    },
    domdrag() {
      let startX, startY, clientX, clientY
      let dom, zindex
      let draging = false
      document.addEventListener('mousedown', e => {
        if (typeof e.target.className!=="object"&&e.target.className.includes('interview-grade')) {
          e.preventDefault()
          dom = e.target
          zindex = app.root.dragindex++
          startX = dom.offsetLeft
          startY = dom.offsetTop
          clientX = e.clientX
          clientY = e.clientY
          draging = true
        }
      })
      document.addEventListener('mousemove', e => {
        if (draging) {
          e.preventDefault()
          dom.style.left = e.clientX - clientX + startX + 'px'
          dom.style.top = e.clientY - clientY + startY + 'px'
        }
      })
      document.addEventListener('mouseup', e => {
        if (draging) draging = false
      })
    },
  },
  mounted() {
    this.domdrag()
  },
}
</script>
<style src="../../statistics/css/interviewGrade.css" scoped></style>
